import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import ReactDatatable from "@ashvin27/react-datatable";
import AddPairModal from "../Modals/AddPairModal";
import { getPairs } from "../actions/currency";
import { address_showing } from "../lib/displayStatus";
import { FaCopy } from "react-icons/fa";
import toast from "react-hot-toast";

const Pairs = () => {
  const [pairs, setPairs] = useState([]);
  const [filteredPairs, setFilteredPairs] = useState([]);
  const [selectedPair, setSelectedPair] = useState(null);

  const [showAddPair, setShowAddPair] = useState(false);
  const handleShowAddPair = () => setShowAddPair(true);
  const handleCloseAddPair = () => setShowAddPair(false);

  // Fetch all pairs on load
  useEffect(() => {
    getAllPairs();
  }, []);

  const getAllPairs = async () => {
    try {
      const { status, result } = await getPairs({ chainId: "all" });
      if (status) {
        setPairs(result);
        setFilteredPairs(result);
      }
    } catch (err) {
      console.error("getAllPairs_err", err);
    }
  };

  // -------------------------------
  //   FILTER LOGIC
  // -------------------------------
  const pairOptions = pairs.map((pair) => ({
    value: pair._id,
    label: `${pair.token1.symbol} / ${pair.token2.symbol}`,
  }));

  const handleFilterChange = (selectedOption) => {
    setSelectedPair(selectedOption);

    if (!selectedOption) {
      // If cleared, show all pairs
      setFilteredPairs(pairs);
      return;
    }

    const pairId = selectedOption.value;
    const filtered = pairs.filter((pair) => pair._id === pairId);
    setFilteredPairs(filtered);
  };

  // -------------------------------
  //   TABLE COLUMNS
  // -------------------------------
  const columns = [
    {
      key: "symbol",
      text: "Token Pair",
      className: "exchange_table_values text-center",
      align: "center",
      cell: (record) => <p>{record.token1.symbol} / {record.token2.symbol}</p>,
    },
    {
      key: "token1",
      text: "Token 1 Address",
      className: "exchange_table_values text-center",
      align: "center",
      cell: (record) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(record.token1.address);
          toast.success("Copied!");
        };
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{address_showing(record.token1.address)}</p>
            <FaCopy size={16} style={{ cursor: "pointer" }} onClick={handleCopy} />
          </div>
        );
      },
    },
    {
      key: "token2",
      text: "Token 2 Address",
      className: "exchange_table_values text-center",
      align: "center",
      cell: (record) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(record.token2.address);
          toast.success("Copied!");
        };
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{address_showing(record.token2.address)}</p>
            <FaCopy size={16} style={{ cursor: "pointer" }} onClick={handleCopy} />
          </div>
        );
      },
    },
  ];
  
  const customSelectStyles = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      backgroundColor: isHovered || isFocused || isSelected ? "#44D7B6" : "#000",
      color: isHovered || isFocused || isSelected ? "#fff" : "#fff",
      fontSize: "13px",
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",
      fontSize: "13px",
    }),
    // indicatorsContainer: (provided) => ({
    //   ...provided,
    //   height: "40px",
    //   position: "absolute",
    //   right: 0,
    //   top: 0,
    //   padding: 0,
    // }),
    placeholder: (defaultStyles) => ({
      ...defaultStyles,
      color: "#fff",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      borderRadius: 5,
      background: "transparent",
    }),
  };

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    no_data_text: "No Email Templates found!",
    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  return (
    <Container fluid className="common_bg position-relative">
      <Row>
        <Col xl={2} className="p-0 d-none d-xl-block">
          <Sidebar />
        </Col>
        <Col xl={10} lg={12}>
          <Header title={"Pairs"} />

          {/* Filter Dropdown */}
          <div className="my-4 d-flex justify-content-between align-items-center">
            <div className="rp_input_holder rounded-2 px-0">

              <Select
                placeholder="Filter by Token Pair"
                options={pairOptions}
                value={selectedPair}
                onChange={handleFilterChange}
                isClearable
                styles={customSelectStyles}
              />
            </div>
            {/* <button className="orange_small_primary" onClick={handleShowAddPair}>
              Add Pair
            </button> */}
          </div>

          {/* Table */}
          <div className="common_page_scroller pb-5">
            <div className="exchange_table_holder dashboard_box rounded-3">
              <ReactDatatable
                config={config}
                records={filteredPairs}
                columns={columns}
              />
            </div>
          </div>
        </Col>
      </Row>

      {/* Modals */}
      {/* <AddPairModal show={showAddPair} getAllPairs={getAllPairs} handleClose={handleCloseAddPair} /> */}
    </Container>
  );
};

export default Pairs;
